import PageFormView from './PageFormView'
import PageView from './PageView'

export {
    PageFormView,
    PageView
}
